import operations from './operations';
import slashMenu from './slashMenu';

export default {
  operations,
  slashMenu,
};
